<template>
  <div class="modal fade" id="gpx-import-choice-dialog" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('trail_import_dialog.gpx_import_choice_dialog.import_file') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="$t('shared.close')"></button>
        </div>
        <div class="modal-body">
          <p class="mb-3">
            {{ $t('trail_import_dialog.gpx_import_choice_dialog.this_file_contains_a_route_and', { waypoint_count: waypointCount, waypoint_count_2: waypointCount === 1 ? '' : 's' }) }}
          </p>

          <div class="choice-options">
            <div class="choice-card" :class="{ selected: selectedChoice === 'route' }" @click="selectedChoice = 'route'">
              <div class="choice-icon">
                <span class="material-icons">route</span>
              </div>
              <h6>{{ $t('trail_import_dialog.gpx_import_choice_dialog.route_only') }}</h6>
              <p class="small text-muted">{{ $t('trail_import_dialog.gpx_import_choice_dialog.import_the_track_skip_the_waypoints') }}</p>
            </div>

            <div class="choice-card" :class="{ selected: selectedChoice === 'waypoints' }" @click="selectedChoice = 'waypoints'">
              <div class="choice-icon">
                <span class="material-icons">place</span>
              </div>
              <h6>{{ $t('trail_import_dialog.gpx_import_choice_dialog.waypoints_only') }}</h6>
              <p class="small text-muted">{{ $t('trail_import_dialog.gpx_import_choice_dialog.add_the_waypoints_as_hike_highlights') }}</p>
            </div>

            <div class="choice-card" :class="{ selected: selectedChoice === 'both' }" @click="selectedChoice = 'both'">
              <div class="choice-icon">
                <span class="material-icons">done_all</span>
              </div>
              <h6>{{ $t('trail_import_dialog.gpx_import_choice_dialog.both') }}</h6>
              <p class="small text-muted">{{ $t('trail_import_dialog.gpx_import_choice_dialog.import_the_route_and_add_the') }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('shared.cancel_2') }}</button>
          <button type="button" class="btn btn-primary" @click="confirm" :disabled="!selectedChoice">
            {{ $t('trail_import_dialog.gpx_import_choice_dialog.import') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';

export default defineComponent({
  data() {
    return {
      selectedChoice: null,
      waypointCount: 0,
      modal: null,
      resolvePrompt: null,
    };
  },
  mounted() {
    this.modal = new Modal(this.$el);
    // Covers every dismissal path (Cancel button, close icon, backdrop click, ESC)
    // as well as the explicit Import click, which hides the modal itself.
    this.$el.addEventListener('hidden.bs.modal', () => {
      if (this.resolvePrompt) {
        const resolve = this.resolvePrompt;
        this.resolvePrompt = null;
        resolve(null);
      }
    });
  },
  methods: {
    prompt(waypointCount) {
      this.waypointCount = waypointCount;
      this.selectedChoice = null;
      this.modal.show();
      return new Promise((resolve) => {
        this.resolvePrompt = resolve;
      });
    },
    confirm() {
      if (!this.selectedChoice) {
        return;
      }
      const choice = this.selectedChoice;
      const resolve = this.resolvePrompt;
      this.resolvePrompt = null;
      this.modal.hide();
      if (resolve) {
        resolve(choice);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.choice-options {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.choice-card {
  flex: 1 1 30%;
  min-width: 140px;
  padding: 1.25rem 1rem;
  border: 2px solid var(--gray);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;

  &:hover {
    border-color: #fddf00;
    background-color: var(--gray);
  }

  &.selected {
    border-color: #fddf00;
    background-color: var(--gray);
  }

  .choice-icon {
    margin-bottom: 0.5rem;

    .material-icons {
      font-size: 1.75rem;
      color: #fff;
    }
  }

  h6 {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  p {
    margin: 0;
  }
}
</style>
